import { useState, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Box, Button, Grid, TextField as MuiTextField } from '@material-ui/core'
import Typography from 'ui/components/typography'
import { Field, Formik, Form } from 'formik'
import { validateCups } from '@zatopek/core/src/utils/validators'
import { setInvoiceData, uploadInvoiceClear } from 'services/invoice/actions'
import { getInvoiceData } from 'services/invoice/selectors'
import ScanInvoiceContext from './scanInvoiceContext'
import useStyles from './styles'

const ScanInvoiceValidateForm = ({ handleClose, index }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const invoiceData = useSelector(getInvoiceData)

  const { invoiceDataFromFile } = useContext(ScanInvoiceContext)
  const [editMode, setEditMode] = useState(false)

  const validateForm = (values) => {
    const requiredFields = ['cups']
    const errors = requiredFields.reduce(
      (errs, field) => ({
        ...errs,
        ...(values[field] === '' || values[field] === false ? { [field]: t('form.errors.required') } : {}),
      }),
      {}
    )

    if (values.cups && !validateCups(values.cups)) {
      errors.cups = t('form.errors.cups')
    }

    return errors
  }

  const handleFormSubmit = (values) => {
    dispatch(
      setInvoiceData({
        ...invoiceData,
        [index]: { ...values, index },
      })
    )
    dispatch(uploadInvoiceClear())
    handleClose()
  }

  const onClose = () => {
    dispatch(uploadInvoiceClear())
    handleClose()
  }

  return (
    <>
      <Box mb={4}>
        <Typography className={classes.description} variant="basic" color="textPrimary">
          {t('verifyCupsInfo')}
        </Typography>
      </Box>
      <Formik initialValues={{ cups: invoiceDataFromFile?.cups }} validate={validateForm} onSubmit={handleFormSubmit}>
        {({ values, errors, setFieldValue }) => (
          <Form>
            <Grid container spacing={1}>
              <Grid item xs={10} md={6} className={classes.cupsContainer}>
                <Typography className={classes.cupsText} variant="basic" color="textPrimary">
                  {t('supply.cups')}:
                </Typography>

                {editMode ? (
                  <>
                    <Field
                      component={MuiTextField}
                      fullWidth
                      id="cups"
                      name="cups"
                      label={t('supply.cups')}
                      value={values.cups}
                      type="text"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ form: { autocomplete: 'off' } }}
                      onChange={(e) => setFieldValue('cups', e.target.value, true)}
                      error={errors.cups}
                    />
                  </>
                ) : (
                  <Field fullwidth value={values.cups} className={classes.cupsInputDisabled} disabled />
                )}
              </Grid>
              <Grid item xs={10} md={5} className={classes.cupsContainerError}>
                {errors.cups ? <Typography color="error">{errors.cups}</Typography> : null}
              </Grid>
            </Grid>
            <Box>
              <Box>
                <Typography
                  onClick={() => (!editMode || !errors?.cups) && setEditMode(!editMode)}
                  className={editMode && errors?.cups ? classes.changeModeTextDisabled : classes.changeModeText}
                  alignItems="flex-start"
                  variant="basic"
                  color="secondary"
                >
                  {editMode ? t('saveCupsChange') : t('editCups')}
                </Typography>
              </Box>
              <Box className={classes.buttonsContainer} display="flex" alignItems="center" mb={4}>
                <Button onClick={() => onClose()} variant="outlined" color="primary">
                  {t('common.cancel')}
                </Button>
                <Button type="submit" disabled={editMode} variant="contained" color="secondary">
                  {t('common.finish')}
                </Button>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default ScanInvoiceValidateForm
